import React, { useEffect, useState } from 'react';
import CalendarSelector from './CalendarSelector';
import { getEventCategoryOptions } from './calendarCategories';

export default function SwitchCategory({ event, socket, eventCategories }) {
    const [category, setCategory] = useState(event.event_category || 'general');

    useEffect(() => {
        setCategory(event.event_category || 'general');
    }, [event.hash, event.event_category]);

    useEffect(() => {
        const onCategoryChanged = update => {
            if (update?.hash === event.hash) setCategory(update.event_category);
        };
        socket.on?.('.event_category_changed', onCategoryChanged);
        return () => socket.off?.('.event_category_changed', onCategoryChanged);
    }, [event.hash, socket]);

    return (
        <CalendarSelector
            label="Categoria"
            options={getEventCategoryOptions(eventCategories, category)}
            selectedValues={category}
            onSelect={value => {
                if (value === category) return;
                setCategory(value);
                socket.emit('.change_event_category', event.hash, value);
            }}
        />
    );
}
